import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import "./IndivididualConfidenceModal.scss";
import { Dialog } from "../../../../../components/dialog/Dialog";
import {
  CodeDetection,
  ConfidenceLevels,
} from "../../../../../services/inspection/VideoAnalysisService";
import { NumberSelection } from "../../../../../components/number-selection/NumberSelection";
import { IndivididualConfidenceModalProps } from "./AnalysisIndivididualConfidenceModal";
import { translationService } from "../../../../../services/translation/TranslationService";
import {
  DataSection,
  SubSection,
} from "../../../../../components/data-components/sections/DataSections";

export default observer(function DetectionIndivididualConfidenceModal({
  videoAnalysisService,
  analysisConfidenceStorage,
}: IndivididualConfidenceModalProps) {
  const [confidenceLevels, setConfidenceLevels] = useState<ConfidenceLevels>({});

  useEffect(() => {
    async function getConfidenceLevels() {
      const confidenceLevels: ConfidenceLevels = {};

      if (analysisConfidenceStorage.HighlightLevels.length === 0) {
        await analysisConfidenceStorage.load();
      }

      analysisConfidenceStorage.HighlightLevels.forEach((code) => {
        confidenceLevels[code.name] = code.level;
      });

      setConfidenceLevels(confidenceLevels);
    }

    getConfidenceLevels();
  }, [analysisConfidenceStorage]);

  const confirmIndividualConfidence = () => {
    const processedConfidenceLevels: ConfidenceLevels = {};

    videoAnalysisService.detectedGroupCodes.forEach((code) => {
      processedConfidenceLevels[code.code] = confidenceLevels[code.code] / 100;
    });

    videoAnalysisService.setIndividualDetectionConfidence(processedConfidenceLevels);
    videoAnalysisService.hideDetectionIndivididualConfidenceModal();
  };

  const getNumberSelection = (code: CodeDetection) => {
    const translatedDetection = translationService.translate(
      `damages.highlight-detection.${code.code.replace(/\s+/g, "-").toLowerCase()}`
    );

    return (
      <NumberSelection
        key={code.code}
        initialValue={confidenceLevels[code.code]}
        minValue={65}
        maxValue={100}
        step={5}
        labelTranslationKey={translationService.translate("general.add-percentage-at-end", {
          text: translatedDetection,
        })}
        callback={(newValue) => {
          setConfidenceLevels((prev) => {
            return {
              ...prev,
              [code.code]: newValue,
            };
          });
        }}
      />
    );
  };

  return (
    <Dialog
      sidePosition
      isVisible={videoAnalysisService.shouldShowDetectionIndivididualConfidenceModal}
      onHide={videoAnalysisService.hideDetectionIndivididualConfidenceModal}
      titleKey={"analysis.detection-individual-confidence.title"}
      subTextKey={"analysis.detection-individual-confidence.subtitle"}
      buttonOk={{
        textKey: "general.apply",
        action: confirmIndividualConfidence,
      }}
      buttonCancel={{
        textKey: "general.cancel",
        action: () => {
          videoAnalysisService.hideDetectionIndivididualConfidenceModal();
        },
      }}
    >
      <DataSection>
        <SubSection>
          {videoAnalysisService.detectedGroupCodes
            .slice(undefined, videoAnalysisService.detectedGroupCodes.length / 2 + 1)
            .map((code) => getNumberSelection(code))}
        </SubSection>
        <SubSection>
          {videoAnalysisService.detectedGroupCodes
            .slice(videoAnalysisService.detectedGroupCodes.length / 2 + 1)
            .map((code) => getNumberSelection(code))}
        </SubSection>
      </DataSection>
    </Dialog>
  );
});
